// extracted by mini-css-extract-plugin
export default {"root":"FormSelectAsync_root__QgpPX","fullWidth":"FormSelectAsync_fullWidth__uSapE"};